"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractComponent_1 = __importDefault(require("../../../../../ww_project/Resources/Private/app/components/AbstractComponent"));
var constants_1 = require("../data/constants");
var constants_2 = require("../../../../../ww_project/Resources/Private/app/data/constants");
var constantsClasses_1 = require("../../../../../ww_project/Resources/Private/app/data/constantsClasses");
var EventsDetail = /** @class */ (function (_super) {
    __extends(EventsDetail, _super);
    function EventsDetail() {
        var _this = _super.call(this, constants_1.DATA_EVENTS_DETAIL) || this;
        if (!_this.getElement())
            return _this;
        _this.addingEventNameToForm();
        _this.hideForm();
        return _this;
    }
    EventsDetail.prototype.addingEventNameToForm = function () {
        var eventName = this.getElement().getAttribute(constants_1.DATA_EVENTS_DETAIL);
        var hiddenFields = document.querySelectorAll('form input[type="hidden"]');
        hiddenFields.forEach(function (field) {
            if (field.getAttribute('name').includes('event')) {
                field.setAttribute('value', eventName);
            }
        });
    };
    EventsDetail.prototype.hideForm = function () {
        if (this.getElement().getAttribute(constants_2.DATA_FORM_HIDE)) {
            //       const form = document.querySelector(`[${DATA_FORM}]`)
            //       form.classList.add(CLASS_DNONE)
            var nodeList = document.querySelectorAll("[".concat(constants_2.DATA_FORM, "]"));
            if (nodeList.length == 1) {
                nodeList[0].classList.add(constantsClasses_1.CLASS_DNONE);
            }
            else if (nodeList.length > 1) {
                nodeList[nodeList.length - 1].classList.add(constantsClasses_1.CLASS_DNONE);
            }
        }
    };
    return EventsDetail;
}(AbstractComponent_1.default));
exports.default = EventsDetail;
